import React from 'react';
import { Copy, Done } from '@lt/components/icons-react';
import { i18n } from '@lt/localization';
import { COPY_ICON_TEST_ID, DONE_ICON_TEST_ID } from './constants';

interface CopyIconProps {
  copied: boolean;
  classNameDone?: string;
  classNameCopy?: string;
  onClick?: () => void;
}

const CopyIcon: React.FC<CopyIconProps> = ({
  copied,
  onClick,
  classNameDone,
  classNameCopy,
}) => (
  <>
    {copied ? (
      <Done className={classNameDone} data-testid={DONE_ICON_TEST_ID} />
    ) : (
      <Copy
        className={classNameCopy}
        onClick={onClick}
        aria-label={i18n.t('mobile_apps_banner.copyPromoCode')}
        data-testid={COPY_ICON_TEST_ID}
      />
    )}
  </>
);

export default CopyIcon;
